import getApi from '../../api'
import { StatsAgentProfileList } from '../../model/StatsAssistant'

export const listAgents = () => getApi().get<StatsAgentProfileList>('/stats_assistant/agents')
